import React, { useEffect, useState, useCallback } from 'react'
import classNames from 'classnames'
import { useSelector, useDispatch } from 'react-redux'
import { Route } from 'react-router-dom'

import { updateCurrentUser } from '../../../../ducks/users'
import { fetchView, getView } from '../../../../ducks/views'
import { FullScreenLoader } from '../../../Shared/Loading'
import Page, { TrialBannerContext } from '../../../Shared/Page'
import AppLoader from '../../../App/AppLoader'

import Navigation from './Navigation'
import Header from './Header'
import List from './List'
import ActionModal from './ActionModal'

import styles from './List.module.css'

const View = function View({ match }) {
  const [query, setQuery] = useState('')
  const { viewId } = match.params
  const dispatch = useDispatch()
  const view = useSelector(getView(viewId))

  useEffect(() => {
    dispatch(fetchView(viewId))
    dispatch(updateCurrentUser({ lastViewId: viewId }))
  }, [viewId, dispatch])

  const handleSearch = useCallback(
    text => {
      setQuery(text)
    },
    [setQuery]
  )

  if (!view) {
    return <FullScreenLoader />
  }

  return (
    <div className={styles.wrapper}>
      <TrialBannerContext.Consumer>
        {trialBannerActive => (
          <>
            <div
              className={classNames(
                styles.nav,
                trialBannerActive && styles.bannerActive
              )}
            >
              <Navigation />
            </div>
            <Header
              viewId={viewId}
              tableName={view.name}
              query={query}
              onChangeQuery={handleSearch}
            />
            <List view={view} query={query} />
          </>
        )}
      </TrialBannerContext.Consumer>
    </div>
  )
}

export default function Wrapper(props) {
  return (
    <>
      <Page fullWidth>
        <AppLoader>
          <View {...props} />
        </AppLoader>
      </Page>
      <Route
        path="/databases/views/:viewId/actions/:actionId"
        component={ActionModal}
      />
    </>
  )
}
